import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Leftbar from "./Leftbar";
import Header from "./Header";

export default function Layout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  return (
    <div className="app-wrapper d-flex">
      {/* Overlay for mobile to close sidebar when clicking outside */}
      {isMobileOpen && (
        <div
          className="sidebar-overlay d-lg-none"
          onClick={() => setIsMobileOpen(false)}
        ></div>
      )}

      <Leftbar
        isCollapsed={isCollapsed}
        isMobileOpen={isMobileOpen}
        closeMobile={() => setIsMobileOpen(false)}
      />

      <div
        className={`main-content flex-grow-1 ${isCollapsed ? "collapsed" : ""}`}
      >
        <Header
          toggleCollapse={() => setIsCollapsed((p) => !p)}
          openMobile={() => setIsMobileOpen(true)}
        />
        <main className="p-4">
          <Outlet />
        </main>
      </div>
      <style>{`
        .app-wrapper {
          background-color: #fff;
          min-height: 100vh;
        }

        .main-content {
          margin-left: 260px;
          transition: all 0.3s ease-in-out;
          min-width: 0; /* Prevents flex items from overflowing */
        }

        .main-content.collapsed {
          margin-left: 80px;
        }

        .sidebar-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.5);
          z-index: 1040;
        }

        @media (max-width: 991px) {
          .main-content, .main-content.collapsed {
            margin-left: 0;
          }
        }
      `}</style>
    </div>
  );
}
